import isArray from 'lodash/isArray';
import isObject from 'lodash/isObject';
import isString from 'lodash/isString';


/**
 * @param {ReduxRouterStateOptions} options
 */
export function validateOptions(options) {
  if (!isString(options.idParam)) {
    throw new Error('ReduxRequest missing required idParam');
  }
  if (!isArray(options.stateNames)) {
    throw new Error('ReduxRequest missing required stateNames');
  }
  if (!isObject(options.logger)) {
    throw new Error('ReduxRequest missing required logger');
  }
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/redux-ui-router-utils/utils.js